import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'tun-search-icon',
  templateUrl: './search-icon.component.html',
  styleUrls: ['./search-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchIconComponent {}
